<ng-container *transloco="let t">
  <tui-items-with-more [required]="displayedSequencePreviews">
    @for (sequence of sequences; track sequence.sequenceInstance.id) {
      <div
        *tuiItem
        class="group relative mr-2 h-24 w-24"
        [attr.data-testid]="'sequence-' + sequence.sequenceInstance.id">
        @if (sequence.medias.length > 0) {
          <pxc-sequence-media
            class="h-24 w-24 cursor-pointer rounded-sm"
            [attr.data-testid]="'sequence-media-' + sequence.sequenceInstance.id"
            [media]="sequence.medias[0]" />
          <button
            class="absolute! right-1 top-1 z-10 opacity-0 group-hover:opacity-100"
            size="xs"
            tuiButtonX
            type="button"
            [attr.data-testid]="'delete-sequence-' + sequence.sequenceInstance.id"
            (click)="deleteSequence(sequence, $event)"></button>
        }
      </div>
    }
    <ng-template let-index tuiMore>
      @let remaining = getRemaining(index);
      @let firstHiddenSequence = sequences[index];
      <div class="relative mr-2 h-24 w-24 cursor-pointer overflow-hidden rounded-sm" (click)="clickMore.emit()">
        @if (firstHiddenSequence.medias.length > 0) {
          <pxc-sequence-media
            [attr.data-testid]="'sequence-media-' + firstHiddenSequence.sequenceInstance.id"
            [media]="firstHiddenSequence.medias[0]" />
        }
        <div
          class="absolute inset-0 flex flex-col items-center justify-center bg-black/50 text-center text-text-primary-on-brand">
          +{{ remaining }}
        </div>
      </div>
    </ng-template>
  </tui-items-with-more>
</ng-container>
